//import baseStore from '../../index'

const state = {
  videPlaying: false,
}

const mutations = {
  VIDEO_PLAYING(state, playload) {
    state.videPlaying = playload
  },
}

const actions = {
  closeVideo({ dispatch }) {
    dispatch('videoStarted', false)
    document.body.style.overflowY = 'auto'
  },
  playVideo({ dispatch }) {
    document.body.style.overflowY = 'hidden'
    dispatch('videoStarted', true)
  },
  videoStarted({ commit }, started) {
    //console.log('videoStarted', started)
    commit('VIDEO_PLAYING', started)
    if (!global.isOffline) return
    if (started) {
      window.top.ipcRenderer.send("videoPlaying")
    } else {
      window.top.ipcRenderer.send("videoStopped")
    }
  },
}

const getters = {
  isVideoPlaying: (state) => state.videPlaying,
}

const videosModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

export default videosModule
